import { Component, HostListener, OnInit } from '@angular/core';
import { PuzzleService } from '../services/puzzle.service';
import { Integration } from '../interfaces/integration';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalService } from '../services/local.service';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.css'],
})
export class IntegrationsComponent implements OnInit {
  scrolled: boolean = false;
  integrations: Integration[] = [];
  imgPath: string = 'https://webapi.haibuhr.com';
  activeLang: string = 'Es';

  fbIcon: SafeResourceUrl = '../../assets/icons/facebook-icon.svg';
  igIcon: SafeResourceUrl = '../../assets/icons/ig-icon.svg';
  linkedinIcon: SafeResourceUrl = '../../assets/icons/linkedin-icon.svg';
  ytIcon: SafeResourceUrl = '../../assets/icons/yt-icon.svg';

  constructor(
    private puzzleService: PuzzleService, 
    private router: Router,
    private translate: TranslateService,
    private localService: LocalService,
  ) {}

  // detectar scroll
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (window.scrollY > 0) {
      this.scrolled = true;
    } else {
      this.scrolled = false;
    }
  }

  ngOnInit(): void {
    this.initializeLanguage();
    this.getIntegrations();

    this.translate.onLangChange.subscribe((event) => {
      this.activeLang = event.lang == 'esp' ? 'Es' : 'En';
      this.getIntegrations();
    });
  }

  initializeLanguage() {
    if (this.localService.getJsonValue('lang')) {
      this.translate.use(this.localService.getJsonValue('lang'));
      this.activeLang = this.localService.getJsonValue('lang') == 'eng' ? 'En' : 'Es';
    } else {
      const browserLang = this.translate.getBrowserLang();
      let appLang = this.mapBrowserLangToAppLang(browserLang);
      this.translate.use(appLang);
      this.activeLang = appLang == 'eng' ? 'En' : 'Es';
      this.localService.setJsonValue('lang', appLang);
    }
  }

  mapBrowserLangToAppLang(browserLang: string): string {
    const langMap = {
      en: 'eng',
      es: 'esp',
    };
    return langMap[browserLang] || 'eng';
  }

  getIntegrations() {
    const params = {
      V_LANGUAGE: this.activeLang,
    };
    this.puzzleService.getIntegrations(params).subscribe((res) => {
      this.integrations = res.data?.integrations;
    });
  }

  goToIntegration(integrationName: string) {
    this.router.navigate(['/integrations', integrationName]);
  }
}
